export default __webpack_public_path__ + "static/media/login-bg-38.04c21726.jpg";